var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-ruler"},_vm._l((_vm.hours),function(hour){return _c('div',{key:hour,staticClass:"time-slot",class:{
      passed: _vm.isPassed(hour),
      current: _vm.isCurrent(hour),
      future: _vm.isFuture(hour)
    },on:{"click":function($event){return _vm.handleSlotClick(hour)}}},[_c('div',{staticClass:"time-label"},[_vm._v(_vm._s(hour)+":00")]),_c('div',{staticClass:"time-indicator"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }